import { render } from "./ThreeScene.vue?vue&type=template&id=346a333f"
import script from "./ThreeScene.vue?vue&type=script&lang=js"
export * from "./ThreeScene.vue?vue&type=script&lang=js"
script.render = render

export default script